module.exports = __webpack_public_path__ + "static/img/icon-zhibo@2x.0a3dce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/icon-zhibo@2x.png
// module id = 907
// module chunks = 0